<ng-container *ngIf="isNewEDPScoreboard; else setGameScoreboard">
    <div class="set-game-scoreboard" [class.tennis]="isTennis">
        <ng-container *ngTemplateOutlet="setGameScoreboard" />
    </div>
    <div class="score-container" *ngIf="score.participant1.points">
        <ms-score-card
            [eventId]="event.id"
            [participant1Score]="setPoints[0]"
            [participant2Score]="setPoints[1]"
            [showSeparator]="!isNewEDPScoreboard" />
    </div>
</ng-container>

<ng-template #setGameScoreboard>
    <div class="participant">
        <ms-participant-image *ngIf="!isDoublesPlayer" [participantImage]="event.participants[0].image" [sportId]="event.sport.id" />
        <ms-scoreboard-participant
            class="participant-info"
            [event]="event"
            [participant]="event.participants[0]"
            [isNewEDPScoreboard]="isNewEDPScoreboard"
            [showIndicator]="false" />
        <ng-container *ngIf="!isNewEDPScoreboard; else tennisIcon">
            <div class="serving" [class.serving-indicator]="score.currentlyServing === 1 && !isSuspendedOrFinished"></div>
            <ng-container *ngIf="score.participant1 && score.participant1.points">
                <div class="set points">{{ score.participant1.points }}</div>
                <span class="score-divider"></span>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="score.participant1">
            <div
                class="set"
                *ngFor="let set of score.participant1.sets; let i = index"
                [ngClass]="{ 'highlighted': set.current, 'setWon': set.setWon, 'future-set': set.isFutureSet }">
                {{ set.points }}
                <div class="tie-breaker" *ngIf="isNewEDPScoreboard && set.tieBreakPoints">{{ set.tieBreakPoints }}</div>
            </div>
        </ng-container>
    </div>

    <div class="participant">
        <ms-participant-image *ngIf="!isDoublesPlayer" [participantImage]="event.participants[1].image" [sportId]="event.sport.id" />
        <ms-scoreboard-participant
            class="participant-info"
            [event]="event"
            [participant]="event.participants[1]"
            [isNewEDPScoreboard]="isNewEDPScoreboard"
            [showIndicator]="false" />
        <ng-container *ngIf="!isNewEDPScoreboard; else tennisIconPlayer2">
            <div class="serving" [class.serving-indicator]="score.currentlyServing === 2 && !isSuspendedOrFinished"></div>
            <ng-container *ngIf="score.participant2 && score.participant2.points">
                <div class="set points">{{ score.participant2.points }}</div>
                <span class="score-divider"></span>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="score.participant2">
            <div
                class="set"
                *ngFor="let set of score.participant2.sets; let i = index"
                [ngClass]="{ 'highlighted': set.current, 'setWon': set.setWon, 'future-set': set.isFutureSet }">
                {{ set.points }}
                <div class="tie-breaker" *ngIf="isNewEDPScoreboard && set.tieBreakPoints !== null">{{ set.tieBreakPoints }}</div>
            </div>
        </ng-container>
    </div>

    <div class="header">
        <div class="set-score" *ngIf="score">{{ sitecoreEventDetails.eventDetails.Sets }} {{ score.setScore }}</div>
        <div class="event-time">
            <ng-container *ngIf="!isNewEDPScoreboard; else liveIcon">
                <ms-best-of [scoreboard]="event.scoreboard" />
            </ng-container>
            <ms-event-timer [live]="event.live" [start]="event.startDate" [scoreboard]="event.scoreboard" />
            <div class="set-point" *ngIf="score">{{ score.setPoint }}</div>
        </div>
        <ng-container *ngIf="isNewEDPScoreboard">
            <div class="innings-header" *ngFor="let set of score.participant1.sets; let i = index">{{ i + 1 }}</div>
        </ng-container>
    </div>
    <ng-template #liveIcon>
        <i class="live-icon"></i>
    </ng-template>

    <ng-template #tennisIcon>
        <ng-container *ngIf="score.currentlyServing === 1 && !isSuspendedOrFinished">
            <vn-icon name="sports-sb-tennis" class="tennis-icon" size="12" />
        </ng-container>
    </ng-template>

    <ng-template #tennisIconPlayer2>
        <ng-container *ngIf="score.currentlyServing === 2 && !isSuspendedOrFinished">
            <vn-icon name="sports-sb-tennis" class="tennis-icon" size="12" />
        </ng-container>
    </ng-template>
</ng-template>
